import React from 'react'
import { H2 } from 'components/Heading'
import { useSelector } from 'react-redux'
import { List } from 'immutable'
import _get from 'lodash/get'
import { selectStaticTextByKey } from 'services/static-text/selectors'
import { PlanGridCurrency } from 'components/PlanGridCurrency'
import SherpaMessage from 'components/SherpaMessage'
import { selectUserLanguagePrimary } from 'services/user'
import { EN } from 'services/languages/constants'
import { selectCurrencyIso, selectPlansLoaded } from 'services/plans/selectors'
import { get as getConfig } from 'config'
import { GIFT_PLAN_SELECT_KEY } from './gift-plan-select-key'
import { GiftPlanGrid } from './GiftPlanGrid'

const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

/**
 * @param {String} language
 * @returns {String} BEM language modificator
 */
function getLanguageSpecificClassName (language) {
  if (EN) {
    return ''
  }
  if (typeof language === 'string') {
    return `gift-plan-select__header-title--${language}`
  }
  return ''
}

/**
 * @type {import('react').FC}
 * */
export const GiftPlanSelect = (props) => {
  const { planData } = props
  const staticText = useSelector(selectStaticTextByKey(GIFT_PLAN_SELECT_KEY))
  const currencyIso = useSelector(selectCurrencyIso)
  let isPlansLoaded = useSelector(selectPlansLoaded)
  const userLanguage = useSelector(selectUserLanguagePrimary)

  if (planGraphQLActive && List.isList(planData) && planData.size) {
    isPlansLoaded = true
  }

  return (
    <div className="gift-plan-select">
      {isPlansLoaded ? (
        <>
          <div className="gift-plan-select__header">
            <H2
              className={`gift-plan-select__header-title ${getLanguageSpecificClassName(
                userLanguage,
              )}`}
            >
              {staticText.get('title')}
            </H2>
            {currencyIso && (
              <PlanGridCurrency
                currencyIso={currencyIso}
                className="gift-plan-select__currency-taxes"
              />
            )}
          </div>
          <GiftPlanGrid planData={planData} />
        </>
      ) : (
        <SherpaMessage
          message={staticText.get('loadingPlans')}
          arrow={false}
          center
        />
      )}
    </div>
  )
}

export default GiftPlanSelect
